module.exports = __webpack_public_path__ + "static/media/Source Info.f7947708.txt";